import { Controller } from '@hotwired/stimulus';

import { repeated } from '@/modules/mask';

export default class extends Controller {
  connect() {
    repeated(this.element, { lazy: true }, '0', 3, 4);
  }
}
